import { render, staticRenderFns } from "./UserProfileDetailAuditComponent.vue?vue&type=template&id=8d5b19fe&scoped=true&"
import script from "./UserProfileDetailAuditComponent.vue?vue&type=script&lang=js&"
export * from "./UserProfileDetailAuditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b19fe",
  null
  
)

export default component.exports